import type { Ref } from 'vue'
import { computed } from 'vue'

export default function useSyncProp<
  T,
  U extends string,
  E extends (event: `update:${U}`, value: T) => void
>(ref: Ref<T>, name: U, emit: E) {
  const model = computed<T>({
    get: () => ref.value,
    set: (v) => {
      emit(`update:${name}`, v)
    },
  })

  return model
}
